import * as React from 'react';
import './SideBar.scss';
import classNames from 'classnames';
import { connect } from 'react-redux';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import Clock from '../Clock/Clock';
import CurrentWeather from '../CurrentWeather/CurrentWeather';
import * as actions from '../../actions/actions';
import { getSpecialLogo } from '../../utils/util';

type Props = {
  weather: Object,
  logo: string,
  city: string
};

class SideBar extends React.Component<Props> {
  constructor(props) {
    super(props);
  }

  componentDidMount = () => {};

  render() {
    const { weather } = this.props;

    let { logo } = this.props;
    let { city } = this.props;
    logo = getSpecialLogo(logo);
    return (
      <Drawer
        variant="permanent"
        classes={{
          root: classNames('sidebar-wrap'),
          paper: classNames('sidebar')
        }}
      >
        <div className="sidebar-inner">
          {logo !== undefined ? (
            <div className="logo-outner">
              <img className="logo" src={logo} alt="logo" />
            </div>
          ) : (
            <div className="logo-outner" />
          )}
          {weather.current !== undefined && (
            <CurrentWeather
              currentTemp={weather.current.temperature}
              humidity={null}
              code={weather.current.weather_code}
              showC={false}
              city={city}
            />
          )}
          <Divider
            classes={{
              root: classNames('divider')
            }}
          />
          {weather.location !== undefined ? (
            <Clock timezone={weather.location.timezone_id} />
          ) : null}
        </div>
      </Drawer>
    );
  }
}

const mapStateToProps = state => {
  return {
    weather: state.widgetReducer.weather
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loadForecast: days => {
      dispatch(actions.loadWeather(days));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SideBar);
